export enum CHAT_ACTIONS {
  FETCH_MESSAGES = 'FETCH_MESSAGES',
  GET_CHAT_BY_ID = 'GET_CHAT_BY_ID',
  SEND_MESSAGE = 'SEND_MESSAGE',
}

export enum CHAT_LOADERS {
  FETCH_MESSAGES = 'FETCH_MESSAGES',
  GET_CHAT_BY_ID = 'GET_CHAT_BY_ID',
  SEND_MESSAGE = 'SEND_MESSAGE',
}

export const chatTabs = [
  {
    label: 'Tutti',
    value: 'all',
  },
  {
    label: 'Nuovi',
    value: 'new',
  },
  {
    label: 'Letti',
    value: 'read',
  },
] as const;

const chatTabsValues = chatTabs.map(({ value }) => value);
export type ChatTabValue = (typeof chatTabsValues)[number];
